import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from 'projects/store/src/environments/environment';

@Component({
  template: ''
})
export class RedirectKredicashComponent implements OnInit {
  constructor(private router: Router, private route: ActivatedRoute) {}

  ngOnInit() {
    const source = this.route.snapshot.queryParamMap.get('source');
    if (source === 'web-page') {
      this.router.navigate(['ventas/kredicash-cliente/categoria/kredicash'], { queryParams: { start_token: environment.tokenKredicash.webPage }});
    }
  }
}
